function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React from "react";

var _ref2 = /*#__PURE__*/React.createElement("style", {
  type: "text/css"
}, "\r\n\t.logo-st0{fill:#FFFFFF;}\r\n\t.logo-st1{fill:#FFC605;}\r\n");

var _ref3 = /*#__PURE__*/React.createElement("path", {
  className: "logo-st0",
  d: "M48,30.7l-5.4,3.1l-5.4,3.1v-2.6H9.8H9.7v0.1V51v0.1h0.1h24.5v24.5v0.1h0.1H51h0.1v-0.1v-8.5l7.2-5.9v14.4 c0,2-0.8,3.9-2.2,5.2c-1.3,1.3-3.2,2.2-5.2,2.2H34.4c-2,0-3.9-0.8-5.2-2.2c-1.3-1.3-2.2-3.2-2.2-5.2V58.4H9.8c-2,0-3.9-0.8-5.2-2.2 C3.3,54.9,2.4,53,2.4,51V34.5c0-2,0.8-3.9,2.2-5.2c1.3-1.3,3.2-2.2,5.2-2.2h27.5v-2.6l5.4,3.1L48,30.7z"
});

var _ref4 = /*#__PURE__*/React.createElement("path", {
  className: "logo-st1",
  d: "M27,23.8v-14c0-2,0.8-3.9,2.2-5.2c1.3-1.3,3.2-2.2,5.2-2.2H51c2,0,3.9,0.8,5.2,2.2c1.3,1.3,2.2,3.2,2.2,5.2 v17.3h17.3c2,0,3.9,0.8,5.2,2.2c1.3,1.3,2.2,3.2,2.2,5.2V51c0,2-0.8,3.9-2.2,5.2s-3.2,2.2-5.2,2.2H48.2V61l-5.4-3.1l-5.4-3.1 l5.4-3.1l5.4-3.1v2.6h27.5h0.1v-0.1V34.5v-0.1h-0.1H51.1V9.8V9.7H51H34.4h-0.1v0.1v9L27,23.8z"
});

var _ref5 = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
  className: "logo-st0",
  d: "M105,60h-6.6V28.5h14.4c6.1,0,9.8,3.9,9.8,10.1c0,2.9-1.6,10.1-10.1,10.1H105V60z M111.1,43.2 c4.9,0,4.9-3.5,4.9-4.9c0-3.1-1.7-4.3-5.8-4.3H105v9.3L111.1,43.2L111.1,43.2z"
}), /*#__PURE__*/React.createElement("path", {
  className: "logo-st0",
  d: "M126.6,36.7h5.9v4h0.1c1.3-2.4,2.7-4.7,6.4-4.7c0.4,0,0.8,0,1.2,0.1v6.2c-0.5-0.1-1.2-0.1-1.8-0.1 c-4.8,0-5.7,3-5.7,5.6V60h-6.1V36.7z"
}), /*#__PURE__*/React.createElement("path", {
  className: "logo-st0",
  d: "M154.2,60.6c-6.3,0-11.9-3.9-11.9-12.3S148,36,154.2,36c6.3,0,11.9,3.9,11.9,12.3S160.5,60.6,154.2,60.6z  M154.2,41.2c-4.7,0-5.6,4.1-5.6,7.1s0.9,7.1,5.6,7.1s5.6-4.1,5.6-7.1S159,41.2,154.2,41.2z"
}), /*#__PURE__*/React.createElement("path", {
  className: "logo-st0",
  d: "M177.1,36.7h3.8v4.4h-3.8v12.7c0,1.4,0,1.9,2.5,1.9c0.4,0,0.8,0,1.3-0.1v4.7c-1,0-1.9,0.1-2.9,0.1h-0.8 c-5.3,0-6.3-2-6.3-5.1V41.1h-3.2v-4.4h3.2v-6.3h6.1L177.1,36.7L177.1,36.7z"
}), /*#__PURE__*/React.createElement("path", {
  className: "logo-st0",
  d: "M204.8,53.2c-1.6,5.6-6.3,7.5-10.3,7.5c-6.6,0-11.6-3.2-11.6-12.8c0-2.8,1-11.8,11.2-11.8 c4.6,0,11,2.2,11,12.9v1h-16c0.2,1.8,0.5,5.7,5.5,5.7c1.7,0,3.5-0.9,4-2.5H204.8L204.8,53.2z M198.7,46c-0.4-3.8-2.8-4.9-4.7-4.9 c-2.9,0-4.4,1.8-4.8,4.9H198.7z"
}), /*#__PURE__*/React.createElement("path", {
  className: "logo-st0",
  d: "M224.6,43h13.2v17h-4.4l-0.7-4c-1.7,1.9-4.1,4.8-9.8,4.8c-7.6,0-14.5-5.4-14.5-16.5c0-8.6,4.7-16.7,15.3-16.7 h0.1c9.7,0,13.5,6.3,13.8,10.6H231c0-1.2-2.2-5.2-6.9-5.2s-9,3.2-9,11.3c0,8.6,4.7,10.8,9.2,10.8c1.4,0,6.3-0.6,7.6-6.9h-7.3V43 L224.6,43z"
}), /*#__PURE__*/React.createElement("path", {
  className: "logo-st0",
  d: "M257.7,27.7c4.2,0,15.1,1.8,15.1,16.6s-11,16.6-15.1,16.6c-4.2,0-15.1-1.8-15.1-16.6S253.5,27.7,257.7,27.7z  M257.7,55.3c3.6,0,8.6-2.2,8.6-11s-5-11-8.6-11s-8.6,2.2-8.6,11S254.1,55.3,257.7,55.3z"
}));

var _ref6 = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
  className: "logo-st0",
  d: "M295,50.3c0,1.8,0.9,5.1,6.7,5.1c3.1,0,6.6-0.7,6.6-4.1c0-2.5-2.4-3.1-5.7-3.9l-3.4-0.8 c-5.1-1.2-10-2.3-10-9.3c0-3.5,1.9-9.7,12.1-9.7c9.7,0,12.2,6.3,12.3,10.2h-6.3c-0.2-1.4-0.7-4.7-6.5-4.7c-2.5,0-5.5,0.9-5.5,3.8 c0,2.5,2,3,3.3,3.3l7.7,1.9c4.3,1.1,8.3,2.8,8.3,8.5c0,9.5-9.7,10.3-12.4,10.3c-11.5,0-13.5-6.6-13.5-10.5L295,50.3L295,50.3z"
}), /*#__PURE__*/React.createElement("path", {
  className: "logo-st0",
  d: "M338.3,55.5c0,2.8,0.6,3.4,1.4,3.6V60H333c-0.4-1.1-0.4-1.4-0.6-2.8c-1.4,1.5-3.4,3.4-7.6,3.4 c-3.5,0-7.1-2-7.1-6.8c0-4.6,2.9-6.9,6.8-7.5l5.5-0.8c1-0.1,2.2-0.5,2.2-1.8c0-2.6-2.5-2.7-4-2.7c-3.1,0-3.6,1.9-3.8,3.2h-5.9 c0.7-7.2,5.7-8.2,10.5-8.2c3.3,0,9.3,1,9.3,6.8V55.5L338.3,55.5z M332.3,48.7c-0.6,0.5-1.6,0.9-4.2,1.3c-2.3,0.4-4.2,1-4.2,3.5 c0,2.2,1.7,2.8,2.9,2.8c2.7,0,5.5-1.8,5.5-4.6L332.3,48.7L332.3,48.7z"
}), /*#__PURE__*/React.createElement("path", {
  className: "logo-st0",
  d: "M350.8,60h-6.1V41h-3.4v-4.4h3.4v-1.9c0-4.8,2.6-6.7,6.9-6.7c1.8,0,2.6,0,3.2,0.1v5h-1.7 c-2.1,0-2.2,0.7-2.2,2.6v0.9h4V41h-4L350.8,60L350.8,60z"
}), /*#__PURE__*/React.createElement("path", {
  className: "logo-st0",
  d: "M378.3,53.2c-1.6,5.6-6.3,7.5-10.3,7.5c-6.6,0-11.6-3.2-11.6-12.8c0-2.8,1-11.8,11.2-11.8 c4.6,0,11,2.2,11,12.9v1h-16c0.2,1.8,0.5,5.7,5.5,5.7c1.7,0,3.5-0.9,4-2.5H378.3L378.3,53.2z M372.2,46c-0.4-3.8-2.8-4.9-4.7-4.9 c-2.9,0-4.4,1.8-4.8,4.9H372.2z"
}));

var SvgProtegosafeLogoWhite = function SvgProtegosafeLogoWhite(_ref) {
  var svgRef = _ref.svgRef,
      title = _ref.title,
      props = _objectWithoutProperties(_ref, ["svgRef", "title"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Warstwa_1",
    x: "0px",
    y: "0px",
    width: "380.9px",
    height: "85.5px",
    viewBox: "0 0 380.9 85.5",
    style: {
      enableBackground: "new 0 0 380.9 85.5"
    },
    xmlSpace: "preserve",
    ref: svgRef
  }, props), title ? /*#__PURE__*/React.createElement("title", null, title) : null, _ref2, _ref3, _ref4, _ref5, _ref6);
};

var ForwardRef = React.forwardRef(function (props, ref) {
  return /*#__PURE__*/React.createElement(SvgProtegosafeLogoWhite, _extends({
    svgRef: ref
  }, props));
});
export default __webpack_public_path__ + "static/media/protegosafe_logo_white.8bc1d4b5.svg";
export { ForwardRef as ReactComponent };